import GedcomX from '../../shared/helpers/gedcom_X'

const gcx = GedcomX()

const defaultAncestorData = {
  personId: null,
  name: null,
  surname: null,
  displayName: '',
  atn: null,
  dob: null,
  pob: null,
  pobId: null,
  dod: null,
  pod: null,
  podId: null,
  genderType: '',
  living: true,
  portraitThumbnailLink: '',
  lifespan: null,
}

const treeInitialState = {
  // These we will show until the tree info is retrieved from the back end.
  userTree: {
    1: { ...defaultAncestorData, atn: 1, genderType: gcx.MALE },
    2: { ...defaultAncestorData, atn: 2, genderType: gcx.MALE },
    3: { ...defaultAncestorData, atn: 3, genderType: gcx.FEMALE },
    4: { ...defaultAncestorData, atn: 4, genderType: gcx.MALE },
    5: { ...defaultAncestorData, atn: 5, genderType: gcx.FEMALE },
    6: { ...defaultAncestorData, atn: 6, genderType: gcx.MALE },
    7: { ...defaultAncestorData, atn: 7, genderType: gcx.FEMALE },
  },
  includeLocation: true,
  anchorATN: 2,
}

const treeReducer = (state, action) => {
  const change = { ...state }

  switch (action.type) {
    case 'TREE_INIT_STATE': {
      change.userTree = action.payload.data
      break
    }
    case 'EDIT_ANCESTOR': {
      change.anchorATN = action.payload.atn
      break
    }
    case 'COMMIT_ANCESTOR': {
      const recordToChange = change.userTree[action.payload.person.atn]
      Object.assign(recordToChange, action.payload.person)
      break
    }
    case 'COMMIT_TREE': {
      break
    }
    default: {
      // console.warn(`Unhandled case: ${action.type}`)
    }
  }
  return { ...change }
}

export { treeInitialState, treeReducer }
